// removed by extract-text-webpack-plugin
module.exports = {"Quote":"_2FXt_Bxk","LeftBar":"_1SzRf3pa","Text":"_1flbAv-Z","Author":"_2idzJCg6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/quote/quote-component.styles.scss
// module id = 247
// module chunks = 0